import styled from "styled-components";

export const CompanyListHeaderContainer = styled.div`
    paddingLeft: 10px;
    paddingRight: 10px;    
`

export const CompanyListHeaderTable = styled.table`
    width:100%;
`

export const CompanyListHeaderTableData = styled.td<{width?: string}>`
    width:${props=>props.width? props.width : '100%;'}
`

export const CompanyListContainer = styled.div<{isMobile?: boolean}>`
    background-color: white;
    height: 65vh;
    overflow-y: auto;
    margin-bottom: 20px;

    ::-webkit-scrollbar {
        width: 5px;
    }

    ::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #E0F0F5; 
        border-radius: 8px;
    }
    
    ::-webkit-scrollbar-thumb {
        background: #556ED1; 
        border-radius: 5px;
    }

    @media screen and (max-width: 1500px){
        height: 55vh;
    }
`
export const CompanyListItemContainer = styled.div`
    padding-left:5px;
    padding-right:15px;
`